<template>
  <div class="PKManagement">
    <el-card>
      <div class="title">今日（{{todayDetail.name}}赛季）
        <el-button type="primary" size="small" class="fr" @click="setPK">设置PK</el-button>
      </div>
      <el-table style="margin-top: 20px" :data="todayList" border>
        <el-table-column align="center" label="段位" prop="">
          <template>PK数量</template>
        </el-table-column>
        <el-table-column v-for="item in danList" :key="item.id" align="center" :label="item.name" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.gradeNumber">
              {{ JSON.parse(scope.row.gradeNumber)['grade' + item.id] || 0 }}
            </span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="lookThis(scope.row)">查看</a>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card style="margin-top: 10px">
      历史数据: <el-select v-model="filter.seasonId" @change="getListPageForSJ1" size="small">
        <el-option v-for="item in sjList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>

      <el-table style="margin-top: 10px" :data="historyList" border>
        <el-table-column align="center" label="日期" prop="thatDate"></el-table-column>
        <el-table-column v-for="item in danList" :key="item.id" align="center" :label="item.name + '段位PK数量'" prop="">
          <template slot-scope="scope">
            {{ JSON.parse(scope.row.gradeNumber)['grade' + item.id] || 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="lookThis(scope.row)">查看</a>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="text-align: center; margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
      :before-close="handleClose">
      <el-radio-group v-model="grade" @change="changeRadio">
        <el-radio-button v-for="item in danList" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
      </el-radio-group>
      <div style="margin: 10px 0"></div>
      <el-select v-model="addForm.seasonTeamAId" @change="changeOp" size="small" filterable>
        <el-option v-for="(item, i) in teamList" :key="i" :disabled="item.disable" :label="item.name" :value="item.id"></el-option>
      </el-select>
      PK
      <el-select v-model="addForm.seasonTeamBId" @change="changeOp" size="small" filterable>
        <el-option v-for="(item, i) in teamList" :key="i" :disabled="item.disable" :label="item.name" :value="item.id"></el-option>
        <el-option label="人机" :value="0"></el-option>
      </el-select>
      <el-button type="primary" size="small" style="margin: 0 10px;" @click="addSeasonTeamPk">添加</el-button>
      <el-button type="primary" size="small" @click="importExcel">导入</el-button>
      <el-button type="primary" size="small" class="fr" @click="download">下载模板</el-button>

      <p style="color: #f00; margin: 10px 0;">（注意：选好后请确认后再添加，添加成功即直接生效，不可进行更改！！！）</p>

      <el-table :data="teamList2" border>
        <el-table-column align="center" label="战队名称" prop="seasonTeamAName"></el-table-column>
        <el-table-column align="center" label="PK" prop="">
          <template>PK</template>
        </el-table-column>
        <el-table-column align="center" label="战队名称" prop="seasonTeamBName"></el-table-column>
      </el-table>

      <el-pagination
        style="text-align: center; margin-top: 10px"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="filterAdd.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filterAdd.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1">
      </el-pagination>
    </el-dialog>

    <a ref="link" href="https://public.kpjushi.cn/%E6%A8%A1%E6%9D%BF.xlsx"></a>

    <TeamDetail v-model="dialogVisible1" :row="row" :danList="danList" />
    <ImportExcel v-model="dialogVisible2" />
  </div>
</template>

<script>
import { getTodayStatis, getUsableTeamList, addSeasonTeamPk, getListPageForTeam, getListPageForSJ, getCurrSeasons, getAllSeasons } from '@/api/season/vip.js'
import TeamDetail from './components/TeamDetail'
import ImportExcel from './components/ImportExcel'
import dayjs from 'dayjs'
export default {
  name: 'PKManagement',
  components: { TeamDetail, ImportExcel },
  data () {
    return {
      danList: [
        {
          id: 1,
          name: '青铜'
        },
        {
          id: 2,
          name: '白银'
        },
        {
          id: 3,
          name: '黄金'
        },
        {
          id: 4,
          name: '铂金'
        },
        {
          id: 5,
          name: '钻石'
        },
        {
          id: 6,
          name: '星耀'
        },
        {
          id: 7,
          name: '王者'
        },
      ],
      sjList: [],
      todayList: [],
      filter: {
        page: 1,
        limit: 10,
        seasonId: ''
      },
      total: 0,
      total1: 0,
      historyList: [],
      title: '今日',
      dialogVisible: false,
      grade: 1,
      teamList: [],
      addForm: {
        seasonTeamAId: '',
        seasonTeamBId: ''
      },
      filterAdd: {
        limit: 10,
        page: 1
      },
      thatDate: '',
      teamList2: [],
      dialogVisible1: false,
      dialogVisible2: false,
      row: {},
      seasonName: '',
      todayDetail: {}
    }
  },
  created() {
    this.getCurrSeasons()
    this.getAllSeasons()
    this.getTodayStatis()
  },
  watch: {
    dialogVisible(nv) {
      if (nv) {
        this.changeRadio()
        this.title = `今日（${this.todayDetail.name || ''}赛季）${dayjs().format('YYYY-MM-DD')}`
      }
    },
    dialogVisible2(nv) {
      if (!nv) {
        this.getListPageForTeam()
      }
    }
  },
  methods: {
    async getCurrSeasons() {
      const res = await getCurrSeasons()
      this.todayDetail = res.data
    },
    async getAllSeasons () {
      const res = await getAllSeasons()
      this.sjList = res.data
      this.filter.seasonId = this.sjList.length ? this.sjList[0].id : 0
    },
    async getTodayStatis() {
      const res = await getTodayStatis()
      if (!res.data) {
        this.getListPageForSJ()
        return
      }
      // if (res.data.gradeNumber) {
      //   }
      this.todayList = [res.data]
      this.thatDate = res.data.thatDate || dayjs().format('YYYY-MM-DD') + ' '
      this.seasonName = res.data.seasonName
      this.getListPageForSJ()
    },
    getListPageForSJ1() {
      this.filter.page = 1
      this.filter.limit = 10
      this.getListPageForSJ()
    },
    async getListPageForSJ () {
      const res = await getListPageForSJ(this.filter)
      this.historyList = res.data.records
      this.total = +res.data.total
    },
    async getUsableTeamList() {
      const res = await getUsableTeamList({grade: this.grade})
      this.teamList = res.data.map(item => {
        item.disable = false
        return item
      })
    },
    async getListPageForTeam() {
      const res = await getListPageForTeam({...this.filterAdd, date: dayjs().format('YYYY-MM-DD'), grade: this.grade})
      this.teamList2 = res.data.records
      this.total1 = +res.data.total
    },
    async addSeasonTeamPk() {
      if (!this.addForm.seasonTeamAId || this.addForm.seasonTeamBId === '') {
        return this.$message.error('请选择战队后继续添加')
      }
      const sendObj = {
        grade: this.grade,
        seasonTeamAName: this.teamList.find(col => col.id === this.addForm.seasonTeamAId).name,
        seasonTeamBName: this.addForm.seasonTeamBId !== 0 ? this.teamList.find(col => col.id === this.addForm.seasonTeamBId).name : '人机',
        ...this.addForm
      }
      const res = await addSeasonTeamPk(sendObj)
      this.$message.success('添加成功')
      this.addForm = {
        seasonTeamAId: '',
        seasonTeamBId: ''
      }
      this.getUsableTeamList()
      this.getListPageForTeam()
    },
    setPK() {
      if (!this.filter.seasonId) {
        return this.$message.error('今日无赛季, 不可设置PK')
      }
      this.dialogVisible = true
    },
    download() {
      this.$refs.link.click()
    },
    changeRadio() {
      this.getUsableTeamList()
      this.getListPageForTeam()
    },
    changeOp(id) {
      if (!id) return
      this.teamList.forEach(item => {
        if (item.id !== id) {
          item.disable = false
        } else {
          item.disable = true
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.filterAdd = {
        limit: 10,
        page: 1
      }
      this.addForm = {
        seasonTeamAId: '',
        seasonTeamBId: ''
      }
      this.getTodayStatis()
    },
    lookThis(row) {
      this.dialogVisible1 = true
      row.seasonName = this.sjList.find(item => +item.id === +row.seasonId).name
      this.row = row
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getListPageForSJ()
    },
    handleSizeChange(v) {
      this.filter.limit = v
      this.filter.page = 1
      this.getListPageForSJ()
    },
    handleCurrentChange1(v) {
      this.filterAdd.page = v
      this.getListPageForTeam()
    },
    handleSizeChange1(v) {
      this.filterAdd.limit = v
      this.filterAdd.page = 1
      this.getListPageForTeam()
    },
    importExcel() {
      this.dialogVisible2 = true
    }
  }
}
</script>

<style lang="scss" scoped>
.PKManagement {
  .title {
    font-size: 16px;
  }
  .fr {
    float: right;
  }
}
</style>
